import React from "react";

// components
export default function Download() {
  return (
    <>
      <div className="flex flex-wrap">
        <div className="w-full lg:w-12/12 px-4">

            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-gray-200 border-0">
                <div className="rounded-t bg-white mb-0 px-6 py-6">
                    <div className="text-center flex justify-between">
                        <h6 className="text-gray-800 text-xl font-bold">DOWNLOAD</h6>
                    </div>
                </div>
                <div className="flex-auto px-4 lg:px-10 py-10 pt-0">
                <form>
                    <h6 className="text-gray-500 text-sm mt-3 mb-6 font-bold uppercase">              
                    </h6>
                    <div className="flex flex-wrap">
                        
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="relative w-full mb-3">    
                                <iframe width="560" height="315" src="https://www.youtube.com/embed/bWUXfRT8_xI" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="relative w-full mb-3">    
                                <iframe width="560" height="315" src="https://www.youtube.com/embed/TPxoRipJ27o" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                            </div>
                        </div>

                        <div className="w-full lg:w-12/12 px-4">
                            <div className="relative w-full mb-3">
                                <label
                                    className="block uppercase text-gray-700 text-xs font-bold mb-2"
                                    htmlFor="grid-password"
                                >
                                    <b>List of Version</b>
                                </label>
                                <div className="relative w-full mb-8 mt-6">
                                    <span className="bg-blue-500 text-white uppercase text-base px-8 py-3 rounded shadow-md hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150">
                                        &nbsp;<i className="fa fa-download"></i> <a href="https://mega.nz/file/j0MGhKiC#rrtw5JxK2EFrikJBOKcQP-RT-lwGgFzhWqJYDYQYbxw" target="_blank"><b>MBLink Cluster V2.51</b> Standalone Installation</a>&nbsp;
                                    </span>
                                </div>
                                <div className="relative w-full mb-3">
                                    <span className="bg-blue-500 text-white uppercase text-base px-8 py-3 rounded shadow-md hover:shadow-lg outline-none focus:outline-none mr-1 mb-1">
                                        &nbsp;<i className="fa fa-download"></i> <a href="https://mega.nz/file/yw1QWRCa#jiHixuCH1Glf156FpfZRA_czLwg7p2CNoBLKCKZbyew" target="_blank"><b>MBLink Cluster V2.51</b> With Toolkit and OpenPort2 Drivers</a>&nbsp;
                                    </span>
                                </div>

                                Notice: Installation password is "mblinktools"<br/><br/>
                                <b>MBlink Requirements:</b><br/>
                                Windows 10 x64, x32<br/><br/>
                                <b>Devices:</b><br/>
                                ECOM or SDConnect C4 or Orginal Bosch MTS6532<br/>
                                Passthru devices (VXDiag, VAS5054, ChipSoft, OpenPort2 etc) are ready.

                            </div>
                        </div>
                        <div className="w-full lg:w-12/12 px-4">
                            <div className="relative w-full mb-3">
                                <label
                                    className="block uppercase text-gray-700 text-xs font-bold mb-2"
                                    htmlFor="grid-password"
                                >
                                    <b>Map Application</b>
                                </label>
                                <div className="relative w-full mb-8 mt-6">
                                    <span className="bg-blue-500 text-white uppercase text-base px-8 py-3 rounded shadow-md hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150">
                                        &nbsp;<i className="fa fa-download"></i> <a href="https://mega.nz/file/fl11ASJZ#tw8-6XnnYjiEiDl6tOXcaaeAW2_kDhKCpS9JNJyLZsA" target="_blank"><b>Map Downloader</b></a>&nbsp;
                                    </span>
                                </div>
                                <div className="relative w-full mb-3">
                                    <span className="bg-blue-500 text-white uppercase text-base px-8 py-3 rounded shadow-md hover:shadow-lg outline-none focus:outline-none mr-1 mb-1">
                                        &nbsp;<i className="fa fa-download"></i> <a href="https://mega.nz/file/it1kESIT#1TiNhCcfdJFdsK0ZhXeBJp_-NFMp984DQH68FeQY-NM" target="_blank"><b>Empty Map Data</b></a>&nbsp;
                                    </span>
                                </div>

                                
                            </div>
                        </div>              
                    </div>

                    <hr className="mt-6 border-b-1 border-gray-400" />

                </form>
                </div>
            </div>

        </div>
      </div>
    </>
  );
}
